import { useState } from "react";
import { heroTags, site } from "@/mocks/manga";

export default function Hero({ onSearch }: { onSearch: (keyword: string) => void }) {
  const [keyword, setKeyword] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(keyword);
    document.getElementById("update")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative flex min-h-[540px] w-full flex-col items-center justify-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20ninja%20village%20silhouette%20under%20dramatic%20fiery%20orange%20and%20crimson%20sunset%20sky%2C%20large%20fire%20sparks%20floating%20in%20air%2C%20mountain%20peaks%20and%20cliff%20faces%2C%20warm%20glowing%20atmosphere%2C%20hand-drawn%20ink%20and%20digital%20illustration%2C%20epic%20cinematic%20composition%2C%20no%20text&width=1600&height=900&seq=hero-ninja-village&orientation=landscape"
          alt="火影同人漫画 - 忍者村落落日大图"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950/80"></div>
      </div>

      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center px-4 pt-24 pb-16 text-center md:px-6">
        <span className="mb-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white/10 px-4 py-1.5 text-xs text-background-50/90 ring-1 ring-white/20">
          <i className="ri-fire-line"></i> 每日无删减同步追更
        </span>
        <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          {site.name}
        </h1>
        <p className="mt-3 font-heading text-base font-semibold text-secondary-400 md:text-xl">
          {site.slogan}
        </p>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
          {site.desc}，覆盖全集、汉化与每日更新，火影同人漫画无删减章节一站看完。
        </p>

        <form onSubmit={submit} className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center">
          <label className="flex flex-1 items-center gap-2 rounded-lg bg-background-50/95 px-4 py-3 ring-1 ring-white/20">
            <i className="ri-search-line text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索火影同人漫画作品名…"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <button
            type="submit"
            className="whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索作品
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {heroTags.map((tag) => (
            <span key={tag} className="whitespace-nowrap rounded-md bg-black/25 px-3 py-1.5 text-xs text-background-100/90 ring-1 ring-white/10">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}